<template>
  <div class="tw-mt-4 tw-mb-5">
    <button @click="toggleShowContent" class="tw-w-full">
      <h4
        class="
          tw-flex
          tw-mx-3
          tw-text-ugray-400
          tw-font-semibold
          tw-text-sm
          tw-items-center
        "
      >
        Pacientes aguardando
        <span :class="`${filteredAppointments.length == 0 ? 'tw-hidden': 'tw-flex'} tw-bg-blue-400  tw-h-5 tw-items-center tw-justify-center tw-ml-2 tw-rounded-full tw-text-white tw-w-5 tw-text-xs`" >
          {{ filteredAppointments.length }}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          :class="`${!showContent ? 'tw-rotate-180' : 'tw-rotate-0'} tw-transition-all tw-ml-auto tw-w-4 tw-h-4`"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4.5 15.75l7.5-7.5 7.5 7.5"
          />
        </svg>
      </h4>
    </button>
    <div v-show="showContent" class="">
      <div v-if="loading" class="tw-text-center tw-px-2 tw-text-ugray-400">Carregando</div>
      <div
        v-if="!loading && filteredAppointments.length === 0"
        class="tw-text-center tw-px-2 tw-text-gray-400"
      >
        <svg class="tw-mx-auto" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M5.125 19.925q-.3 0-.512-.187-.213-.188-.213-.488v-1h-.3q-1 0-1.687-.7-.688-.7-.688-1.7v-4.925q0-1.075.725-1.725.725-.65 1.65-.65V6.775q0-1 .7-1.688.7-.687 1.7-.687h11.025q1 0 1.7.687.7.688.7 1.688V8.55q.975 0 1.675.675.7.675.7 1.7v4.925q0 1-.687 1.7-.688.7-1.688.7H19.6v1q0 .3-.187.488-.188.187-.488.187t-.5-.187q-.2-.188-.2-.488v-1H5.8v1q0 .275-.187.475-.188.2-.488.2ZM4.1 16.85h15.825q.4 0 .688-.275.287-.275.287-.7v-4.95q0-.425-.287-.7-.288-.275-.688-.275-.425 0-.713.275-.287.275-.287.7V14.6H5.1v-3.675q0-.425-.288-.7-.287-.275-.712-.275-.4 0-.687.275-.288.275-.288.7v4.95q0 .4.288.687.287.288.687.288Zm2.4-3.65h11.025v-2.275q0-.6.275-1.088.275-.487.725-.812v-2.25q0-.4-.287-.687-.288-.288-.713-.288H6.5q-.425 0-.713.288-.287.287-.287.687v2.25q.45.325.725.812.275.488.275 1.088Zm5.525 0Zm0 3.65Zm0-2.25Z"/></svg>
        Nenhum paciente aguardando
      </div>
      <div v-else class="patients-waiting-container tw-px-2 tw-py-1 tw-pt-5">
        <patient-waiting-item
          v-for="appointment in filteredAppointments"
          :key="appointment.id"
          :appointment-detail="appointment"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PatientWaitingItem from "./patient-waiting-item";
let intervalAppointment = null;
const ONE_MINUTE_IN_MILISECONDS = 60000; // 60 * 1000
import { formatDurationTime } from "../../helpers/formatDurationTime";

function formatAppoinment(appointment) {
  const date = new Date(appointment.starts_waiting_at);
  const totalMinutes = (new Date() - date) / ONE_MINUTE_IN_MILISECONDS;

  return {
    ...appointment,
    duration_in_minutes: totalMinutes,
    waiting_time: formatDurationTime(totalMinutes),
  };
}

export default {
  props: ["currentSelectedProfessionalId"],
  components: {
    PatientWaitingItem,
  },
  data() {
    const selectedProfessionalId = Number(this.currentSelectedProfessionalId);
    return {
      appointments: [],
      loading: false,
      selectedProfessionalId: isNaN(selectedProfessionalId)
        ? 0
        : selectedProfessionalId,
      showContent: false,
    };
  },
  mounted() {
    this.fetch();
    intervalAppointment = setInterval(() => {
      this.appointments = this.updateTime(this.appointments);
    }, ONE_MINUTE_IN_MILISECONDS);

    document.addEventListener(
      "patients-waiting/remove",
      this.removePatientTimeHandler
    );
    document.addEventListener(
      "patients-waiting/create",
      this.createPatientTimeHandler
    );
    document.addEventListener(
      "calendar/professional-selected",
      this.professionalSelectedHandler
    );
  },
  unmount() {
    intervalAppointment && clearInterval(intervalAppointment);
    document.removeEventListener(
      "patients-waiting/remove",
      this.removePatientTimeHandler
    );
    document.removeEventListener(
      "patients-waiting/create",
      this.createPatientTimeHandler
    );
    document.removeEventListener(
      "calendar/professional-selected",
      this.professionalSelectedHandler
    );
  },
  computed: {
    filteredAppointments() {
      if (this.selectedProfessionalId == "0") {
        return this.appointments;
      }
      return this.appointments.filter(
        (event) => event.professional.id == this.selectedProfessionalId
      );
    },
  },
  methods: {
    fetch() {
      this.loading = true;
      axios
        .get("/events/patients_waiting", {
          headers: {
            Accept: "application/json",
          },
        })
        .then(({ data }) => {
          this.appointments = this.updateTime(data.data ? data.data : []);
          if (this.appointments.length > 0) {
            this.showContent = localStorage.getItem("hide_patients_waiting") == null
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          Bugsnag.notify(error);
        });
    },
    updateTime(appointments) {
      return appointments.map(formatAppoinment);
    },
    createPatientTimeHandler(event) {
      typeof mixpanel != 'undefined' && mixpanel.track("Created Patients Waiting")
      this.appointments.push(formatAppoinment(event.detail.event));
      if (this.appointments.length == 1 && !this.showContent) {
        this.showContent = true
      }
    },
    removePatientTimeHandler(event) {
      this.appointments = this.appointments.filter(
        (appointment) =>
          appointment.appointment.id != event.detail.event.appointment.id
      );

      if (this.appointments.length == 0) {
        this.showContent = false
      }
    },
    professionalSelectedHandler(event) {
      this.selectedProfessionalId = Number(event.detail.professionalId);
    },
    toggleShowContent() {
      typeof mixpanel != 'undefined' && mixpanel.track("Toggle Patients Waiting Section")
      this.showContent = !this.showContent;
      if (this.showContent) {
        localStorage.removeItem("hide_patients_waiting");
      } else {
        localStorage.setItem("hide_patients_waiting", "1");
      }
    },
  },
};
</script>
